import React from 'react';
import { useTranslation } from 'react-i18next';
import { type FormikProps } from 'formik';
import { paymentTypeEnum } from './paymentTypeEnum';
import { Card } from '@components/card/card';

interface LinesProps {
  formik: FormikProps<any>;
}

// const ApScheduleList: React.FC<LinesProps> = ({ formik }) => {
//   const { values } = formik;

//   const { i18n, t } = useTranslation();

//   const handleLineChange = (index: number, field: string, value: any) => {
//     const updatedLines = [...values.scheduleList];

//     updatedLines[index] = {
//       ...updatedLines[index],
//       amount: value
//     };

//     formik?.setFieldValue('scheduleList', updatedLines);
//   };

//   const handleDeleteLine = (index: number) => {
//     const updatedLines = values.scheduleList?.filter((_: any, i: number) => i !== index);
//     formik?.setFieldValue('scheduleList ', updatedLines);
//   };

//   const calculateTotalSum = () => {
//     const total = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0);
//     const formattedTotal = new Intl.NumberFormat('en-US').format(total);
//     return formattedTotal;
//   };

//   return (
//     <>
//       <div className='row'>
//         <div className='col-12 col-md-3 mb-2'>
//           <div className='rounded-2 p-2 bg-inverse bg-opacity-10'>
//             <div className='d-flex justify-content-between'>
//               <div className='fw-bold'>{t('Total')}:</div>
//               <div className='text-theme fs-5 fw-bold'>{calculateTotalSum()}</div>
//             </div>
//           </div>
//         </div>

//         <div className='col-lg-3'></div>
//         <div className='col-lg-6 text-end '>
//           <div className='text-end mb-2'></div>
//         </div>
//       </div>

//       {values.paymentType !== paymentTypeEnum.PrePayment && (
//         <div className={`table-responsive rounded-2 text-center  `}>
//           <table className='table    text-nowrap  table-hover mb-0'>
//             <thead className='bg-theme bg-opacity-30'>
//               <tr>
//                 <th className='align-middle small'>{t('InvoiceTotal')}</th>
//                 <th className='align-middle small'>{t('InvoiceNumber')}</th>
//                 <th className='align-middle small'>{t('InvoiceDate')}</th>
//                 <th className='align-middle small'>{t('DueDate')}</th>

//                 <th className='align-middle small'>{t('PaymentAmount')}</th>
//                 <th className='align-middle small'>{t('AmountToPay')}</th>

//                 <th className='align-middle text-end'></th>
//               </tr>
//             </thead>

//             <tbody className=' '>
//               {values.scheduleList
//                 ?.slice()

//                 ?.map((line: any, index: any) => {
//                   const Index = index;

//                   return (
//                     <tr key={index}>
//                       <td className='align-middle '>{line.invoiceAmount}</td>
//                       <td className='align-middle '>{line.invoiceNum}</td>
//                       <td className='align-middle '>{line.invoiceDate}</td>
//                       <td className='align-middle '>{line.dueDate}</td>
//                       <td className='align-middle '>{line.schadualAmount}</td>

//                       <td className='align-middle '>
//                         <input
//                           type='text'
//                           autoComplete='off'
//                           className='form-control text-center text-theme fw-bold fs-6'
//                           value={line.amount || 0}
//                           onChange={e => handleLineChange(Index, 'amount', Number(e.target.value))}
//                           onInput={e => {
//                             const input = e.target as HTMLInputElement;

//                             // السماح فقط بالأرقام والنقطة العشرية
//                             input.value = input.value.replace(/[^0-9.]/g, '');

//                             // السماح فقط بنقطة عشرية واحدة
//                             if (input.value.split('.').length > 2) {
//                               input.value = input.value.substring(0, input.value.length - 1);
//                             }
//                             // التحقق من القيمة المدخلة بالنسبة لحد المبلغ المتبقي
//                             if (Number(input.value) > Number(line.actualRemainingAmount)) {
//                               input.value = line.actualRemainingAmount.toString();
//                             }
//                           }}
//                         />
//                       </td>

//                       <td className='align-middle  '>
//                         <button
//                           type='button'
//                           className='btn btn-sm btn-outline-danger'
//                           onClick={() => handleDeleteLine(Index)}
//                         >
//                           <i className='fas fa-trash-alt'></i>
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </>
//   );
// };

const ApScheduleList: React.FC<LinesProps> = ({ formik }) => {
  const { values } = formik;
  // const { i18n, t } = useTranslation();

  const handleLineChange = (index: number, field: string, value: any) => {
    const updatedLines = [...values.scheduleList];
    updatedLines[index] = {
      ...updatedLines[index],
      amount: value
    };
    formik?.setFieldValue('scheduleList', updatedLines);
  };

  const handleDeleteLine = (index: number) => {
    const updatedLines = values.scheduleList?.filter((_: any, i: number) => i !== index);
    formik?.setFieldValue('scheduleList', updatedLines);
  };

  const calculateTotalSum = () => {
    const total = values.scheduleList?.reduce((sum: any, line: any) => sum + (line.amount || 0), 0);
    return total || 0;
  };

  const sortedLines = values.scheduleList?.slice() || [];

  return (
    <>
      {values.paymentType !== paymentTypeEnum.PrePayment && (
        // <Card className='mb-4'>
        <>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h6 className='mb-0'>
              <i className='fas fa-file-invoice me-2'></i>
              قائمة الفواتير المحددة للدفع
              {/* <span className='badge bg-primary ms-2'>فواتير عادية</span> */}
            </h6>
            <div>
              <span className='badge bg-theme bg-opacity-70 me-2 p-2'>عدد الفواتير: {sortedLines.length}</span>
              {/* <span className='badge bg-success'>الإجمالي: {calculateTotalSum().toLocaleString()}</span> */}
            </div>
          </div>

          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='text-center small'>رقم الفاتورة</th>
                    <th className='text-center small'>تاريخ الفاتورة</th>
                    <th className='text-center small'>تاريخ الاستحقاق</th>
                    <th className='text-center small'>مبلغ الفاتورة</th>
                    <th className='text-center small'>المبلغ المتبقي</th>
                    <th className='text-center small w-20'>المبلغ المراد دفعه</th>
                    {/* <th className='text-center small'>الإجراءات</th> */}
                  </tr>
                </thead>
                <tbody>
                  {sortedLines.map((line: any, index: number) => (
                    <tr key={index}>
                      <td className='text-center align-middle'>
                        <span className='fw-bold'>{line.invoiceNum}</span>
                      </td>
                      <td className='text-center align-middle'>{line.invoiceDate}</td>
                      <td className='text-center align-middle'>{line.dueDate}</td>
                      <td className='text-center align-middle'>
                        <span className='fw-bold text-primary'>{Number(line.invoiceAmount).toLocaleString()}</span>
                      </td>
                      <td className='text-center align-middle'>
                        <span className='fw-bold text-success'>
                          {Number(line.actualRemainingAmount).toLocaleString()}
                        </span>
                      </td>
                      <td className='text-center align-middle'>
                        <div className='d-flex align-items-center gap-2 justify-content-center'>
                          <input
                            disabled
                            type='text'
                            className='form-control  text-center fw-bold w-100 bg-secondary bg-opacity-25'
                            value={line.amount || 0}
                          />
                        </div>
                      </td>
                      {/* <td className='text-center align-middle'>
                        <div className='d-flex align-items-center gap-2 justify-content-center'>
                          <input
                            disabled
                            type='text'
                            className='form-control form-control-sm text-center fw-bold'
                            value={line.amount || 0}
                            onChange={e => handleLineChange(index, 'amount', Number(e.target.value))}
                            style={{ width: '120px' }}
                            onInput={e => {
                              const input = e.target as HTMLInputElement;
                              input.value = input.value.replace(/[^0-9.]/g, '');

                              if (input.value.split('.').length > 2) {
                                input.value = input.value.substring(0, input.value.length - 1);
                              }

                              if (parseFloat(input.value) > Number(line.actualRemainingAmount)) {
                                input.value = line.actualRemainingAmount.toString();
                              }
                            }}
                          />
                        </div>
                      </td> */}
                      {/* <td className='text-center align-middle'>
                        <span className=' fw-bold'>{line.amount}</span>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-between align-items-center'>
            <div className='text-muted small'>
              عرض {sortedLines.length} من {sortedLines.length} فاتورة
            </div>
            <div className='text-theme fw-bold fs-5'>المجموع الكلي: {calculateTotalSum().toLocaleString()}</div>
          </div>
        </>
        // </Card>
      )}

      {sortedLines.length === 0 && values.paymentType !== paymentTypeEnum.PrePayment && (
        <div className='alert alert-info d-flex align-items-center mb-4' role='alert'>
          <i className='fas fa-info-circle me-2'></i>
          <div>لا توجد فواتير مضافة للدفع</div>
        </div>
      )}
    </>
  );
};

export default ApScheduleList;
